import { FC, HTMLAttributes, PropsWithChildren, ReactNode } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import { Checkbox as MuiCheckbox, FormControlLabel } from '@mui/material';

import useStyles from '@/designSystem/Form/Checkbox/styles';

export type CheckboxProps = {
  isChecked: boolean;
  name?: string;
  label?: string | ReactNode;
};

export const Checkbox: FC<
  PropsWithChildren<CheckboxProps & HTMLAttributes<HTMLInputElement>>
> = ({ isChecked = false, name = '', label = '', onChange }) => {
  const { classes } = useStyles();

  return (
    <FormControlLabel
      className={classes.root}
      control={
        <MuiCheckbox
          checked={isChecked}
          className={classes.checkbox}
          onChange={onChange}
          checkedIcon={<CheckIcon fontSize="small" />}
          name={name}
        />
      }
      label={label}
    />
  );
};
